import React, { useCallback } from 'react'
import { BiDotsVertical } from 'react-icons/bi'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../Korbantech/components/Buttons/Button'
import { Diagnosis } from '../../types/Diagnosis'


export const DiagnosesNoAnswerList = ({diagnosis}:Props) => {

    const navigate = useNavigate()

    const renderTotalAvage = useCallback((diagnosis:Diagnosis):string => {
        let total=0
        let avarega =0
        if(diagnosis.total)
        total = diagnosis.total
        if(diagnosis.average)
        avarega = diagnosis.average
        let data = (((100*avarega)/total)/10)*1;
        return data.toFixed(1);
    },[])

    return(
        <>
        <div className="col-span-1 text-xl font-bold">{diagnosis.score ? (diagnosis.score*1) : 0}</div>
                  <div className="col-span-4">{diagnosis.name}</div>
                  <div className="col-span-3">
                      <div className="flex items-center gap-x-3">
                          <Button className="" value="Responder teste"
                            onClick={()=>navigate(`/osc/responder/${diagnosis?.id}`)}
                          />
                          <div>{diagnosis.replyAt}</div>
                      </div>
                  </div>
                  <div className='col-span-1'></div>
                  <div className="col-span-2 text-center text-xl font-bold">{renderTotalAvage(diagnosis)}</div>
                  <div className="col-span-1">
                      <BiDotsVertical className="text-gray-500 text-2xl" />
                  </div>
      </>
    )
}

interface Props {

    diagnosis: Diagnosis

}
